module.exports = __webpack_public_path__ + "static/media/Bubble Pop SFX - Game 1.53298a72.mp3";